import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import { useRef } from "react";

export const DetailPanelActions = ({ items }: { items: MenuItem[] }) => {
  const menuRight = useRef<any>(null);

  return (
    <>
      <Menu
        model={items}
        popup
        ref={menuRight}
        id="popup_menu_right"
        className="p-menu-custom-logout"
        popupAlignment="right"
      />
      <Button
        icon={PrimeIcons.ELLIPSIS_V}
        text
        severity="secondary"
        className="width-px-28 height-px-28"
        onClick={(event) => menuRight?.current?.toggle(event)}
      />
    </>
  );
};
